<template>
	<div class="containerMain" v-if="!showNoData">
		<title-bar :topTitle="true"/>
		<div class="col inner" v-if="schoolSummary && schoolSummary.coachingCategories.length > 0">
			<title-bar :title="schoolSummary.itemName" :percentage="schoolSummary.schoolPercentage" percentageTitle="Promedio Colegio"/>
			<div class="row between innerRubric">
				<percentages-summary v-for="coachingCategory in schoolSummary.coachingCategories" :key="coachingCategory.id" :coachingCategory="coachingCategory"></percentages-summary>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import mediator from '@/mediator';

export default {
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		schoolSummary () {
			if (this.$store.state.school.summary) return this.$store.state.school.summary[0];
			else return this.$store.state.school.summary;
		},
		showNoData () {
			return this.$store.state.ui.showNoData;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/school/Summary.vue